module.exports = __webpack_public_path__ + "fc8faf96425e13cfd54d3aa1f2592b92.pdf";